import moment from "moment";
import { User } from "src/app/core/models/auth.models";
import { FileModel } from "./file.model";
import { GroupModel } from "./group.model";
import { NeedModel } from "./need.model";

export class RequirementModel {
  public id: number;

  public requirement: string;
  public description: string;
  public uploadedFiles: FileModel[];

  public authorId: number;
  public groupId: number;
  public needId: number;
  public configurationId: number;

  public author: User;
  public group: GroupModel;
  public need: NeedModel;
  public configuration: any;

  public createdAt: Date;
  public updatedAt: Date | null;

  constructor($obj?: any) {
    this.id = $obj && $obj.id ? $obj.id : '#new' + moment().valueOf();

    this.requirement = $obj && $obj.requirement ? $obj.requirement : '';
    this.description = $obj && $obj.description ? $obj.description : '';
    this.uploadedFiles = $obj && $obj.uploadedFiles ? $obj.uploadedFiles : [];

    this.authorId = $obj && $obj.authorId ? $obj.authorId : $obj && $obj.author ? $obj.author.id : null;
    this.groupId = $obj && $obj.groupId ? $obj.groupId : $obj && $obj.group ? $obj.group.id : null;
    this.needId = $obj && $obj.needId ? $obj.needId : $obj && $obj.need ? $obj.need.id : null;
    this.configurationId = $obj && $obj.configurationId ? $obj.configurationId : $obj && $obj.configuration ? $obj.configuration.id : null;

    this.author = $obj && $obj.author ? $obj.author : null;
    this.group = $obj && $obj.group ? $obj.group : null;
    this.need = $obj && $obj.need ? $obj.need : null;
    this.configuration = $obj && $obj.configuration ? $obj.configuration : null;

    this.createdAt = $obj && $obj.createdAt ? new Date($obj.createdAt) : new Date();
    this.updatedAt = $obj && $obj.updatedAt ? new Date($obj.updatedAt) : null;
  }

  setByForm(form: any): RequirementModel {
    this.needId = form.need === '' ? null : form.need;
    this.groupId = form.group;
    this.requirement = form.requirement;
    this.description = form.description;
    this.configurationId = form.configuration;
    this.uploadedFiles = form.files;
    return this;
  }

  toAPI() {
    return {
      needId: this.needId,
      requirement: this.requirement,
      description: this.description,
      authorId: this.authorId,
      groupId: this.groupId,
      configurationId: this.configurationId
    };
  }
}



